export function line(ctx) {
    return {
        styles: {
            main: { bg_opa: 0, line_color: ctx.TEXT_SEC, line_width: 1, line_rounded: false },
        },
    };
}
